import { useMutation } from '@apollo/client';
import ModalUtils from 'utils/ModalUtils';

const useDocumentsOtherFunctions = ({
    updateMutation,
    deleteMutation,
    deleteMutationReferenceId,
}) => {
    const [updateDocumentsReferenceId] = useMutation(updateMutation, {
        onError: (error) => {
            ModalUtils.errorMessage(null, error);
        },
    });

    const [deleteDocumentsByTemporaryReference] = useMutation(deleteMutation, {
        onError: (error) => {
            ModalUtils.errorMessage(null, error);
        },
    });

    const [deleteDocumentsByReferenceId] = useMutation(deleteMutationReferenceId ?? deleteMutation, {
        onError: (error) => {
            ModalUtils.errorMessage(null, error);
        },
    });

    return {
        updateDocumentsReferenceId,
        deleteDocumentsByTemporaryReference,
        deleteDocumentsByReferenceId,
    };
};

export default useDocumentsOtherFunctions;
